module.exports = __webpack_public_path__ + "assets/img/banner-index01.e6d127ce.jpg";